import React from "react";

/**
 * Delicate spiritual ornament: thin moon arc + dot + small botanical mark.
 * Used as a section divider / accent.
 */
export default function SacredOrnament({ className = "", color = "#9B4422" }) {
    return (
        <svg
            viewBox="0 0 180 28"
            className={className}
            aria-hidden="true"
            fill="none"
            stroke={color}
            strokeWidth="1"
            strokeLinecap="round"
        >
            {/* left vine */}
            <path d="M2 14 H68" />
            <path d="M40 14 c0 -6 6 -10 10 -10" />
            <path d="M40 14 c0 6 6 10 10 10" />
            {/* center: moon + sun + dot */}
            <circle cx="86" cy="14" r="4.5" />
            <path d="M93 14 a6 6 0 1 0 0 0.1" />
            <circle cx="106" cy="14" r="1.6" fill={color} stroke="none" />
            {/* right vine (mirror) */}
            <path d="M112 14 H178" />
            <path d="M140 14 c0 -6 -6 -10 -10 -10" />
            <path d="M140 14 c0 6 -6 10 -10 10" />
        </svg>
    );
}
